export default {"src":"/_next/static/media/lifelong-learner.999a9b62.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};